import type { PassAction } from "../types/actions";
import type { ValidationResult } from "../types/common";
import type { WarchestState } from "../types/game-state";
import { hasCoin } from "../utils/zone-utils";

export function validatePass(
  state: WarchestState,
  action: PassAction,
): ValidationResult {
  if (state.phase !== "USE_COINS") {
    return { valid: false, error: "Not in USE_COINS phase" };
  }
  if (action.player !== state.activePlayer) {
    return { valid: false, error: "Not your turn" };
  }
  const zones = state.playerZones[action.player];
  if (!hasCoin(zones, action.coinType, "hand")) {
    return { valid: false, error: "Coin not in hand" };
  }
  return { valid: true };
}
